// extracted by mini-css-extract-plugin
export default {"footer":"hl0XH","withBottomPadding":"wwjO7","centered":"vWL09","block":"efSnt","titleForApps":"J_GL0","detailsSpacing":"zM9Vd","borderBottom":"ugOBB"};